// 运行时 API Base 统一入口
// 生产环境通过 Nginx 反向代理同源访问，不使用跨域（更安全）。
// - VUE_APP_API_BASE 优先（构建时注入）；生产构建请勿在 .env.production 中写绝对 API 地址，留空或设为 /api
// - 否则按环境：dev 本地后端，prod 同源 /api（由 Nginx 将 /api 反代到后端）

const DEFAULTS = {
  development: 'http://localhost:8848',
  dev: 'http://localhost:8848',
  test: 'https://api.testedu.skillith.cn',
  production: '/api',
  prod: '/api'
}

const ENV =
  process.env.VUE_APP_ENV ||
  process.env.NODE_ENV ||
  'development'

export const API_BASE =
  process.env.VUE_APP_API_BASE ||
  DEFAULTS[ENV] ||
  DEFAULTS.development

